import Vue from 'vue';
import Router from 'vue-router';

// 使用路由
Vue.use(Router);
// 导出路由模块
export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/home',
            component: () => import('@/pages/index/index.vue'),
            children: [
                // 查询
                {
                    path: '/search',
                    name: 'Search',
                    component: () => import('@/pages/search/index.vue')
                },
                // 首页
                {
                    path: '/home',
                    name: 'Home',
                    component: () => import('@/pages/home/index.vue')
                },
                // news
                {
                    path: '/news',
                    name: 'News',
                    component: () => import('@/pages/news/index.vue')
                },
                // About The Court
                {
                    path: '/about-the-court',
                    name: 'About The Court',
                    component: () => import('@/pages/about-the-court/index.vue')
                },
                // judgement
                {
                    path: '/judgement',
                    name: 'Judgement',
                    component: () => import('@/pages/judgement/index.vue')
                },
                // Case Abstract
                {
                    path: '/case-abstract',
                    name: 'Typical cases',
                    component: () => import('@/pages/case-abstract/index.vue')
                },
                // Annual Report
                {
                    path: '/annual-report',
                    name: 'White Papers',
                    component: () => import('@/pages/annual-report/index.vue')
                },
                // Acadmic Communication
                {
                    path: '/acadmic-communication',
                    name: 'Academic Communication',
                    component: () => import('@/pages/acadmic-communication/index.vue')
                },
                // The Voice of Judge
                {
                    path: '/the-voice-of-judge',
                    name: 'The Voice of Judge',
                    component: () => import('@/pages/the-voice-of-judge/index.vue')
                },
                // The Voice of Judge detail
                {
                    path: '/the-voice-of-judge/detail',
                    name: 'The Voice of Judge detail',
                    component: () => import('@/pages/the-voice-of-judge/detail/index.vue')
                },
                // The Voice of Judge
                {
                    path: '/laws-regulations',
                    name: 'Laws&Regulations',
                    component: () => import('@/pages/laws-regulations/index.vue')
                },
                // Data Statistics
                {
                    path: '/data-statistics',
                    name: 'Data Statistics',
                    component: () => import('@/pages/data-statistics/index.vue')
                },
                // 公用详情页
                {
                    path: '/:type/detail',
                    name: 'common detail',
                    component: () => import('@/pages/detail/index.vue')
                },
                // 公用视频播放页面
                {
                    path:'/:type/spbf',
                    name:'spbf',
                    component: () => import('@/pages/detail/spbf/index.vue')
                }
            ]

        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js